import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { uiUsernamesAdd, uiUsernamesRemove } from "Store/Actions";
import { hasNoElements, omitByFn } from "Utils/Array";
import { isNullOrWhiteSpace } from "Utils/String";

export const Usernames = createReducer<string[]>([], {
  [uiUsernamesAdd.type]: (state, { payload: usernames }: PayloadAction<string[]>) => {
    if (hasNoElements(omitByFn(usernames, (username) => isNullOrWhiteSpace(username)))) {
      return state;
    }

    return Array.from(new Set([...state, ...usernames]));
  },
  [uiUsernamesRemove.type]: (state, { payload: usernames }: PayloadAction<string[]>) => {
    if (hasNoElements(omitByFn(usernames, (username) => isNullOrWhiteSpace(username)))) {
      return state;
    }

    return state.filter((username) => !usernames.includes(username));
  }
});
